// Context route definitions
export const APP_HOME = '/';
export const APP_LOGIN = '/login';
export const APP_SYSTEM_MENU = '/app';
export const APP_FEEDBACK_FORM = '/app/form';
export const APP_FEEDBACK_STATUS = '/app/status';
export const APP_AUTHORIZATION_CALLBACK = '/authorization-code/callback';
